import { Helmet } from "react-helmet";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";
import Authority from "../../components/reusables/Authority";
import SolutionCTA from "../../components/solutions/SolutionCTA";
import HowWeWork from "../../components/solutions/HowWeWork";
import CCTVSecurityFaqsBody from "../../components/faqs/CCTVSecurityFaqsBody";
import RelatedCCTVSecurity from "../../components/solutions/cctv/RelatedCCTVSecurity";
import CCTVSecurity from "../../components/solutions/cctv/CCTVSecurity";

export default function CCTV() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/cctv-security"
        />
        <meta
          name="description"
          content="CCTV installation, remote monitoring, access control systems, and IT security solutions for homes, offices, schools, and institutions."
        />
        
        <meta
          property="og:description"
          content="CCTV installation, remote monitoring, access control systems, and IT security solutions for homes, offices, schools, and institutions."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | CCTV Installation & IT Security | Uganda"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | CCTV Installation & IT Security | Uganda"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | CCTV Installation & IT Security | Uganda"
        />
        <meta
          name="twitter:description"
          content="CCTV installation, remote monitoring, access control systems, and IT security solutions for homes, offices, schools, and institutions."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>
          NTUNA.COM | Solutions | CCTV Installation & IT Security | Uganda
        </title>
      </Helmet>
      <SolutionItemHero
        title="CCTV Installation & IT Security"
        subtitle="Secure your premises and systems with professional CCTV installation and IT security solutions that monitor activity, protect your people, assets and peace of mind to ensure reliable performance when you need it most."
        casestudylink="/#"
        CTAtext="Get Free Quote"
        mainCTAlink="https://form.jotform.com/ntuna/get-free-quote"
      />
      <Authority />
      <CCTVSecurity />
      <SolutionCTA ctaTitle="Ready To Have Your CCTV Installation & IT Security Done Right?" />
      <CCTVSecurityFaqsBody />
      <SolutionCTA ctaTitle="Ready To Have Your CCTV Installation & IT Security Done Right?" />
      <HowWeWork />
      <SolutionCTA ctaTitle="Ready To Have Your CCTV Installation & IT Security Done Right?" />
      <RelatedCCTVSecurity />
    </>
  );
}
